import { Drawer as MUIDrawer, DrawerProps } from '@mui/material'

const Drawer = (props: DrawerProps) => (
  <MUIDrawer keepMounted anchor="right" {...props} />
)

export default Drawer
